import { Table, TableBody, TableContainer, TableHead, TableRow, styled } from "@mui/material";
import React from "react";
import { TableComponents, TableVirtuoso } from "react-virtuoso"


interface Props {
    tableDataRef: any
    data: any,
    HeaderContent: any,
    rowContent: any
}


const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '& .MuiTableCell-body': {
        paddingTop: '3px !important',
        paddingBottom: '3px !important',
        paddingRight: '6px !important',
        paddingLeft: '6px !important',
        fontSize: '12px !important',
    },
    '&:nth-of-type(even)': {
        // backgroundColor: '#edf0f280'
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0
    }
}));


const StyledTableHead = styled(TableHead)(({ theme }) => ({
    '& .MuiTableCell-head': {
        paddingTop: '2px !important',
        paddingBottom: '2px !important',
        fontSize: '12px',
    },
}));

const getGroupRowStyle = (item: any) => {
    if (item.hasOwnProperty('groupName')) {
        return {
            width: '100%',
            height: '30px',

        }
    } else if (item.SNO % 2 === 0) {
        return {
            backgroundColor: '#edf0f280'
        }
    }

}


const VTableComponents: TableComponents<any> = {
    Scroller: React.forwardRef<HTMLDivElement>((props, ref) => (
        <TableContainer className="custom-table-scroll custom-table-maxHeight" {...props} ref={ref} />
    )),
    TableHead: (props: any) => (
        <StyledTableHead {...props} />
    ),
    TableRow: ({ item: _item, ...props }) => <StyledTableRow sx={getGroupRowStyle(_item)} {...props} className={_item.hasOwnProperty('groupName') ? 'rowsGroupWrapper' : ''} />,
    TableBody: React.forwardRef<HTMLTableSectionElement>((props, ref) => (
        <TableBody {...props} ref={ref} />
    )),
};

const VirtualTable: React.FC<Props> = (VirtualTableProps) => {

    return (
        <TableVirtuoso
            data={VirtualTableProps.data}
            components={{
                ...VTableComponents,
                Table: (props: any) => (
                    <Table ref={VirtualTableProps.tableDataRef} {...props} />
                ),
            }}
            fixedHeaderContent={VirtualTableProps.HeaderContent}
            itemContent={VirtualTableProps.rowContent}
        />
    )
}


export default VirtualTable